/**
 * Track an "Apply" button click via Meta Pixel.
 * Call this before navigating to /apply.
 */
export const trackApplyClick = () => {
  if (window.fbq) {
    window.fbq('trackCustom', 'StartApplication');
  }
};
